<template>
  <div
    class="menu"
    :class="{home: curSelect === '/'}"
  >
    <div
      v-if="curSelect === '/'"
      class="logo-box"
      @click="handleLogo"
    >
      <img class="logo" :src="logo" alt="img" />
      <img class="logoTxt" :src="logoTxt" alt="txt">
    </div>
    <div
      v-else
      class="logo-box"
      @click="handleLogo"
    >
      <img class="logo1" :src="logo1" alt="img" />
    </div>
    <div class="rows">
      <p
        v-for="(item, index) in menus"
        class="row"
        :class="{active: curSelect.startsWith(item.key)}"
        :key="index"
        @click="handleClick(item)"
      >
        <span class="name">{{item.value}}</span>
        <!--<span class="line"></span>-->
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'index',
  data () {
    const {
      home: { logo, logo1, logoTxt }
    } = this.$images
    return {
      logo,
      logo1,
      logoTxt,
      curSelect: '/',
      menus: [
        { key: '/summary', value: '会社概要' },
        { key: '/culture', value: '企業沿革' },
        { key: '/content', value: '事業内容' },
        { key: '/product', value: '取扱商品' },
        { key: '/future', value: '今後の展望' },
        { key: '/contact', value: 'お問合せ' }
      ]
    }
  },
  mounted () {
    const fn = setTimeout(() => {
      this.curSelect = this.$route.path
      this.$emit('onSelect', this.curSelect)
      this.$EventBus.$on('onSelect', (path) => {
        this.curSelect = path
        window.scrollTo({
          top: 0,
          left: 0
        })
        return false
      })
      clearTimeout(fn)
    }, 200)
  },
  methods: {
    handleClick (item) {
      const { key } = item
      this.curSelect = key
      this.$emit('onSelect', this.curSelect)
      this.$router.push({ path: key })
    },
    handleLogo () {
      this.handleClick({ key: '/', value: '首页' })
    }
  }
}
</script>

<style lang="less" scoped>
.menu{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 0px 75px;

  .logo-box{
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 293px;
    height: 71px;
    margin-left: 62px;
    /*background-color: wheat;*/
    cursor: pointer;
    position: relative;
    z-index: 10;

    .logo{

    }
    .logoTxt{
      margin-left: 13px;
      /*width: 213px;*/
      /*height: 60px;*/
    }
  }

  &.home{
    .logo-box{
      margin-left: 170px;
    }
    .rows{
      position: relative;
      left: -100px;
      .row{
        line-height: 142px;
      }
    }
  }

  .rows{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    .row{
      width: 190px;
      font-family: 04KanjyukuGothic;
      font-weight: 400;
      font-size: 24px;
      color: #323232;
      line-height: 162px;
      position: relative;
      text-align: center;
      cursor: pointer;

      &:active, &:hover {
        outline-width: 0;
      }

      &:hover{
        .name{
          background-size: 100% 2px;
          background-position: 0 100%;
        }
      }

      .name{
        background-image: linear-gradient(#222, #222);
        background-size: 0 2px;
        background-repeat: no-repeat;
        background-position: 100% 100%;
        transition: background-size .3s cubic-bezier(.33,1,.68,1);
        line-height: 40px;
        display: inline-block;
      }

      &.active{
        color: #374475;
        pointer-events: none;
      }
    }
  }
}
</style>
